import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import theme from 'theme/theme';
import Flex from '../Flex';


const TeaserWrapper = styled(Flex)`
  flex-direction: row;
  background: ${theme.colors.white};
  border-bottom: 1px solid ${theme.colors.light};
  &:last-child {
    border: 0;
  }
  ${(props) => props.actions && props.actions.length > 0 && css`
    &:hover {
      cursor: pointer;
      background: ${theme.colors.light};
      .action-col svg {
        fill: ${theme.colors.primary}
      } 
    }
  `}
  
`;

const ActionCol = styled(Flex)`
  margin: 12px 0 12px 12px;
  flex-grow: 0;
  margin-left: auto;
  min-width: 50px;
`;

const Action = styled(Flex)`
  border-left: 1px solid ${theme.colors.light};
  flex-grow: 0;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;


const TeaserIconCol = styled(Flex)`
  background: ${theme.colors.lighter};
  min-width: 50px;
  max-width: 50px;
  align-items: center;
  justify-content: center;
`;

const TeaserMainCol = styled.div`
  margin: 10px 20px;
  flex-direction: column;
`;

const TeaserMetaWrapper = styled(Flex)`
  margin-top: 15px;
`;

const TeaserMeta = styled.div`
  margin-right: 10px;
`;

const Teaser = ({ item, actions, children }) => (
  <TeaserWrapper actions={actions} onClick={() => actions && actions[0].onClick(item)}>

    {children}

    <ActionCol className="action-col">
      {actions && actions.map((action) => (
        <Action key={action.key} className={`action action-${action.key}`}>
          <action.icon
            key={action.key}
            size="23px"
            onClick={(e) => { e.stopPropagation(); action.onClick(item); }}
          />
        </Action>
      ))}
    </ActionCol>

  </TeaserWrapper>
);
Teaser.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  actions: PropTypes.arrayOf(PropTypes.any),
  item: PropTypes.objectOf(PropTypes.any).isRequired,
};
Teaser.defaultProps = {
  actions: null,
};

Teaser.Wrapper = TeaserWrapper;
Teaser.MainCol = TeaserMainCol;
Teaser.IconCol = TeaserIconCol;
Teaser.ActionCol = ActionCol;
Teaser.Action = Action;
Teaser.MetaWrapper = TeaserMetaWrapper;
Teaser.Meta = TeaserMeta;

export default Teaser;
